import * as types from './types'
import http from '../../utils/http'
import Vue from 'vue'

const vue = new Vue()

const state = {
  dispatchPlatformList: {},
  dispatchPlatformMark: 0
}

const actions = {
  // 列表
  [types.DISPATHPLATFORM] (context, params) {
    http.fetch('/api/dispatchPlatform/listBypage', params).then(data => {
      let resdata = JSON.parse(JSON.stringify(data.obj))
      context.commit(types.DISPATHPLATFORM, resdata)
    })
  },
  // 新增
  [types.DISPATHPLATFORMADD] (context, params) {
    http.fetch('/api/dispatchPlatform/add', params).then(data => {
      context.commit(types.DISPATHPLATFORMADD, data)
    })
  },
  // 编辑
  [types.DISPATHPLATFORMUPDATE] (context, params) {
    http.fetch('/api/dispatchPlatform/update', params).then(data => {
      context.commit(types.DISPATHPLATFORMUPDATE, data)
    })
  },
  // 删除
  [types.DISPATHPLATFORMDELETE] (context, params) {
    http.fetch('/api/dispatchPlatform/delete', params).then(data => {
      context.commit(types.DISPATHPLATFORMDELETE, data)
    })
  },
  // 平台下拉框
  [types.DISPATHPLATFORMALL] (context, params) {
    http.fetch('/api/dispatchPlatform/all', params).then(data => {
      context.commit(types.DISPATHPLATFORMALL, data)
    })
  }
}

const mutations = {
  // 列表数据
  [types.DISPATHPLATFORM] (state, data) {
    state.dispatchPlatformList = data
  },
  // 新增
  [types.DISPATHPLATFORMADD] (state, data) {
    if (data.code === 200) {
      state.dispatchPlatformMark = 1
      vue.$message({
        showClose: true,
        message: '新增成功',
        type: 'success'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'warning'
      })
    }
  },
  // 编辑
  [types.DISPATHPLATFORMUPDATE] (state, data) {
    console.log(data)
    if (data.code === 200) {
      state.dispatchPlatformMark = 1
      vue.$message({
        showClose: true,
        message: '编辑成功',
        type: 'success'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'warning'
      })
    }
  },
  // 删除
  [types.DISPATHPLATFORMDELETE] (state, data) {
    console.log(data)
    if (data.code === 200) {
      state.dispatchPlatformMark = 1
      vue.$message({
        showClose: true,
        message: '删除成功',
        type: 'success'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'warning'
      })
    }
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/dispatchPlatform/index.js